import merge from 'lodash/merge'
import type { UseListProps, UseListResult } from '@ztechapps/common.hook'
import { StorageType, useList } from '@ztechapps/common.hook'
import type { CompanyWithContacts } from '@ztechapps/common.contract'
import { useMemo } from 'react'
import { COMPANY_LIST_QUERY } from './query'

export type UseCompanyListProps = Partial<UseListProps>
const STORAGE_KEY = 'companyListFilterCategory'

const DEFAULT_SORT = { name: 1 }
const DEFAULT_LIST_ACTION_OPTIONS = {
  storageType: StorageType.localStorage,
  storageKey: STORAGE_KEY,
}

export const useCompanyWithContactsList = (props?: UseCompanyListProps): UseListResult<CompanyWithContacts> => {
  const mergeUseListProps = useMemo(() => {
    const { query: propsQuery, ...restProps } = props ?? {}

    const finalProps: UseListProps = merge(
      {},
      {
        query: propsQuery ?? COMPANY_LIST_QUERY,
        sort: DEFAULT_SORT,
        limit: 100,
        listActionOptions: DEFAULT_LIST_ACTION_OPTIONS,
      },
      restProps,
      // Ensure query is always set correctly (in case restProps doesn't have it)
      { query: propsQuery ?? COMPANY_LIST_QUERY }
    )

    return finalProps
  }, [props])

  return useList<CompanyWithContacts>(mergeUseListProps)
}
